import {
  SlFormatNumber
} from "./chunk.OHHFJ5RP.js";

// src/components/format-number/format-number.ts
var format_number_default = SlFormatNumber;
SlFormatNumber.define("sl-format-number");

export {
  format_number_default
};
